import React from 'react';
import SaleCommercials from './SaleCommercials';
import { getAgencies } from '../../../utils/dictionaries';

class RentCommercials extends SaleCommercials {
  constructor (props) {
    super(props);
    this.displayName = 'rentCommercials';
    this.agenciesList = getAgencies(props.agenciesList, this.displayName);
  }
}

export default RentCommercials;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/RentCommercials.jsx